import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';

import './BecomePartner.sass';

import usePageTitle from '../../hooks/usePageTitle';

import TypoContainer from '../../uikit/TypoContainer';
import PartnerForm from '../../components/Forms/PartnerForm';
import Bubble from '../../uikit/Bubble';

import type { BecomePartnerQuery$key } from './__generated__/BecomePartnerQuery.graphql';

import { ReactComponent as DudeYellow } from '../../assets/img/dude/dude-yellow.svg';

interface Props {
	query: BecomePartnerQuery$key | null;
}

function Policy(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = useFragment(
		graphql`
			fragment BecomePartnerQuery on HomePublishedContent {
				_children {
					items {
						... on FormPagePublishedContent {
							title
							metaTitle
							formType
							content
							nameLabel
							surnameLabel
							emailLabel
							companyNameLabel
							privacyPolicyLabelText
							partnerAdditionalInfoLabel
							submitButtonLabel
							partnerAdditionalInfoPlaceholder
						}
					}
				}
			}
		`,
		props.query
	);
	const [fetchedData, setFetchedData] = useState<{
		title: string;
		content: string;
		metaTitle: string;
		formType: string;
		nameLabel: string;
		surnameLabel: string;
		emailLabel: string;
		companyNameLabel: string;
		privacyPolicyLabelText: string;
		partnerAdditionalInfoLabel: string;
		submitButtonLabel: string;
		partnerAdditionalInfoPlaceholder: string;
	}>();

	useEffect(() => {
		data._children.items.map(
			(item: {
				metaTitle: string;
				title: string;
				content: string;
				formType: string;
				nameLabel: string;
				surnameLabel: string;
				emailLabel: string;
				companyNameLabel: string;
				privacyPolicyLabelText: string;
				partnerAdditionalInfoLabel: string;
				submitButtonLabel: string;
				partnerAdditionalInfoPlaceholder: string;
			}) => {
				if (
					item &&
					Object.keys(item).length !== 0 &&
					item.formType === 'partner-registration'
				) {
					setFetchedData(item);
				}
			}
		);
	}, [data]);
	usePageTitle(fetchedData?.metaTitle);
	return (
		<div className="become-partner-page">
			<Container>
				<Row className="sticky-layout">
					{fetchedData && (
						<>
							<Col xs={12} lg={5} className="sticky-layout__sidebar">
								<Row className="sticky-layout__sidebar-content">
									<Col
										xs={12}
										md={6}
										lg={12}
										className="sticky-layout__heading"
									>
										<h1 className="uikit-heading-hg">{fetchedData.title}</h1>
									</Col>
									<Col
										xs={12}
										md={6}
										lg={12}
										className="sticky-layout__animation sticky-layout__animation--lg become-partner-page__animation"
									>
										<Bubble align="left-bottom" text="Hello, let's be partners" />
										<DudeYellow />
									</Col>
								</Row>
							</Col>
							<Col
								xs={12}
								lg={{ offset: 1, span: 6 }}
								className="sticky-layout__content"
							>
								<TypoContainer markup={fetchedData.content} />
								<PartnerForm
									nameLabel={fetchedData.nameLabel}
									surnameLabel={fetchedData.surnameLabel}
									emailLabel={fetchedData.emailLabel}
									companyNameLabel={fetchedData.companyNameLabel}
									privacyPolicyLabelText={fetchedData.privacyPolicyLabelText}
									partnerAdditionalInfoLabel={
										fetchedData.partnerAdditionalInfoLabel
									}
									partnerAdditionalInfoPlaceholder={
										fetchedData.partnerAdditionalInfoPlaceholder
									}
									submitButtonLabel={fetchedData.submitButtonLabel}
								/>
							</Col>
						</>
					)}
				</Row>
			</Container>
		</div>
	);
}

export default Policy;
